/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Compare_Row_Platforms_CcInputs */

const en_cad_compare_row_platforms_cc = /** @type {(inputs: Cad_Compare_Row_Platforms_CcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Windows, macOS, Linux, FreeBSD, web`)
};

/**
* | output |
* | --- |
* | "Windows, macOS, Linux, FreeBSD, web" |
*
* @param {Cad_Compare_Row_Platforms_CcInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cad_compare_row_platforms_cc = /** @type {((inputs?: Cad_Compare_Row_Platforms_CcInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Compare_Row_Platforms_CcInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cad_compare_row_platforms_cc(inputs)
});
export { cad_compare_row_platforms_cc as "cad.compare.row_platforms_cc" }